import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

// NG Bootstrap
import { NgbDropdownModule, NgbModal, NgbModalModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';

// Angualar Fire
import { AngularFireAuth } from '@angular/fire/compat/auth';

//icons
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faRightFromBracket } from '@fortawesome/pro-light-svg-icons';
import { AuthService, CoreModule } from '@noovle/core';
import { ResetPasswordComponent } from '../reset-password/reset-password.component';
import { IMenu } from './IMenu.model';

@Component({
  selector: 'app-nav-bar',
  standalone: true,
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss'],
  imports: [CommonModule, RouterModule, NgbNavModule, NgbDropdownModule, FontAwesomeModule,NgbModalModule, CoreModule],
})
export class NavBarComponent {
  @Input() menu!:IMenu;
  faRightFromBracket = faRightFromBracket;

  constructor(
    public fireAuth: AngularFireAuth,
    public authService: AuthService,
    private modalService: NgbModal
  ) {}

  openResetPasswordModal() {
    let currentuser;
    const modalRef = this.modalService.open(ResetPasswordComponent, {
      windowClass: 'blue-modal',
      centered: true,
      size: 'lg',
    });
    modalRef.componentInstance.hasCheckOldPassword = true;
    this.fireAuth.user.pipe((user) => (currentuser = user));
    return modalRef.result;
  }
}
